import React from 'react';

import Typography from 'components/Typography';
import { AmountFormatter } from 'intl';

import { IDescriptionAmount } from './interfaces';

export const DescriptionAmount: React.FC<IDescriptionAmount> = ({
  value,
  ...other
}) => {
  return (
    <Typography {...other}>
      <AmountFormatter value={value} />
    </Typography>
  );
};
